import { formatCurrency } from '../../helpers/formatters.helpers';

interface PricingItem {
  label: string;
  amount: number;
  name: string;
  duration: string;
}

interface PricingTableProps {
  items: PricingItem[];
  total?: number;
  currency?: string;
}

export function PricingTable({ items, total, currency = 'FCFA' }: PricingTableProps) {
  return (
    <div className="space-y-4">
      {/* Table des items */}
      <div className="overflow-hidden rounded-lg border border-slate-200">
        <table className="w-full">
          <thead className="bg-slate-50">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700">Nom</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700">Durée</th>
              <th className="px-4 py-3 text-right text-sm font-semibold text-slate-700">Prix</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200">
            {items.map((item, index) => (
              <tr key={index} className="hover:bg-slate-50 transition-colors">
                <td className="px-4 py-3 text-sm text-slate-900">{item.name}</td>
                <td className="px-4 py-3 text-sm text-slate-600">{item.duration || '-'}</td>
                <td className="px-4 py-3 text-sm text-slate-900 text-right font-medium">
                  {formatCurrency(item.amount)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Total */}
      {total !== undefined && (
        <div className="flex justify-between items-center pt-4 border-t-2 border-slate-300">
          <span className="text-lg font-semibold text-slate-900">Total</span>
          <span className="text-xl font-bold text-slate-900">{formatCurrency(total)}</span>
        </div>
      )}

      {/* Monnaie */}
      {currency && (
        <div className="pt-2 text-sm text-slate-600">
          <span className="font-medium">Monnaie :</span> {currency}
        </div>
      )}
    </div>
  );
}
